import { useDispatch, useSelector } from "react-redux"
import { fetchOrders, selectAll as ordersSelector, changeFirstFetch } from "./ordersSlice";
import { useEffect} from "react";

import { OrdersList } from "./ordersList";

import "./orders.css";



export const Orders = () => {
    const dispatch = useDispatch();
    const table = useSelector(state => state.cart.tableId);
    const firstFetch = useSelector(state => state.orders.firstFetch)
    const orders = useSelector(ordersSelector);

    useEffect(() => {
        return () => {
            document.body.style.overflow = 'visible';
            document.body.style.paddingRight = 0;
        };
    }, []);

    useEffect(() => {
        if (orders.length === 0) {
            dispatch(fetchOrders({table}));
        }
    }, [])

    useEffect(() => {
        const ordersUpdate = setInterval(() => {
            dispatch(fetchOrders({table}));
        }, 10000);
        return () => {
            clearInterval(ordersUpdate);
        };
    }, []);

    if (orders.length === 0) {
        return <p className="h2 text-center mt-5"> Тут поки що нема замовлень. </p>
    }

    return <OrdersList orders={orders} table={table}/>
}